var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLifeRing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_753_8600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.0833 6.99996C4.08341 6.42846 4.25247 5.86974 4.56921 5.39404L1.65955 2.48438C0.588212 3.74505 0 5.34556 0 6.99996C0 8.65436 0.588212 10.2549 1.65955 11.5155L4.56921 8.60588C4.25247 8.13018 4.08341 7.57146 4.0833 6.99996Z",
    fill: "#747F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3403 2.48438L9.43066 5.39404C9.74749 5.8697 9.91655 6.42844 9.91655 6.99996C9.91655 7.57147 9.74749 8.13022 9.43066 8.60588L12.3403 11.5155C13.4117 10.2549 13.9999 8.65436 13.9999 6.99996C13.9999 5.34556 13.4117 3.74505 12.3403 2.48438Z",
    fill: "#747F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99996 9.91658C6.42846 9.91647 5.86974 9.74741 5.39404 9.43066L2.48438 12.3403C3.74505 13.4117 5.34556 13.9999 6.99996 13.9999C8.65436 13.9999 10.2549 13.4117 11.5155 12.3403L8.60588 9.43066C8.13018 9.74741 7.57146 9.91647 6.99996 9.91658Z",
    fill: "#747F9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99996 4.0833C7.57146 4.08341 8.13018 4.25247 8.60588 4.56921L11.5155 1.65955C10.2549 0.588212 8.65436 0 6.99996 0C5.34556 0 3.74505 0.588212 2.48438 1.65955L5.39404 4.56921C5.86974 4.25247 6.42846 4.08341 6.99996 4.0833Z",
    fill: "#747F9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_753_8600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeRing);
export default __webpack_public_path__ + "static/media/life-ring.db28585d4852df11bcc99c6def12bbed.svg";
export { ForwardRef as ReactComponent };